import Reveal from '@/components/feature/Reveal';
import SectionTitle from './SectionTitle';
import { HOT_WORKS } from '@/mocks/anime';

export default function HotWorks() {
  return (
    <section id="hot" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionTitle
          eyebrow="人气TOP"
          title="热门作品推荐"
          desc="精心筛选的高人气动漫作品，入口清晰、打开即看。每周更新信息一目了然，收藏本站随时追更不迷路。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 md:mt-14 md:gap-6">
          {HOT_WORKS.map((item, i) => (
            <Reveal key={item.id} delay={i * 80}>
              <article className="group flex h-full flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-100/60 transition-all hover:-translate-y-1 hover:border-primary-300">
                <div className="relative h-64 overflow-hidden md:h-72">
                  <img
                    src={item.image}
                    alt={`${item.title} ${item.tag} 动漫作品封面`}
                    className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute left-3 top-3 rounded-full bg-black/55 px-3 py-1 text-xs font-semibold text-background-50 backdrop-blur">
                    {item.tag}
                  </span>
                  <span className="absolute right-3 top-3 flex items-center gap-1 rounded-full bg-secondary-400/90 px-2.5 py-1 text-xs font-bold text-foreground-950">
                    <i className="ri-star-fill"></i>
                    {item.score}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <h3 className="font-heading text-lg text-foreground-950">{item.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500">{item.episodes} · {item.update}</p>
                  <p className="mt-3 flex-1 text-sm leading-6 text-foreground-600">{item.desc}</p>
                  <a
                    href="#new"
                    className="mt-4 inline-flex w-fit items-center gap-1.5 rounded-full bg-primary-500 px-4 py-2 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
                  >
                    <i className="ri-play-fill"></i>
                    前往观看
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}